module.exports = __webpack_public_path__ + "img/hourglass.9b319b69.svg";